/**
 * 시드 난수 — 결정론의 2번 규칙.
 *
 * Math.random()은 시뮬레이션 안에서 절대 호출하지 않는다.
 * sfc32(Small Fast Counting)를 쓴다. 32비트 정수 연산만 사용하므로
 * 브라우저·Node·서버 어디서 돌려도 같은 수열이 나온다.
 *
 * 호출 순서도 상태의 일부다. 유닛 순회는 항상 인덱스 오름차순으로만 한다.
 */

function splitmix32(seed: number): () => number {
  let a = seed | 0;
  return () => {
    a = (a + 0x9e3779b9) | 0;
    let t = a ^ (a >>> 16);
    t = Math.imul(t, 0x21f0aaad);
    t = t ^ (t >>> 15);
    t = Math.imul(t, 0x735a2d97);
    return (t = t ^ (t >>> 15)) >>> 0;
  };
}

export class Rng {
  private a = 0;
  private b = 0;
  private c = 0;
  private d = 0;

  constructor(seed: number) {
    this.reseed(seed);
  }

  reseed(seed: number): void {
    const sm = splitmix32(seed);
    this.a = sm();
    this.b = sm();
    this.c = sm();
    this.d = sm();
    for (let i = 0; i < 12; i++) this.next();
  }

  /** 부호 없는 32비트 난수. */
  next(): number {
    const a = this.a;
    const b = this.b;
    const c = this.c;
    const d = this.d;
    const t = (a + b) | 0;
    this.a = b ^ (b >>> 9);
    this.b = (c + (c << 3)) | 0;
    this.c = (c << 21) | (c >>> 11);
    this.d = (d + 1) | 0;
    const r = (t + this.d) | 0;
    this.c = (this.c + r) | 0;
    return r >>> 0;
  }

  /** [0, n) 정수. n > 0. */
  int(n: number): number {
    return this.next() % n;
  }

  /** [lo, hi] 정수. */
  range(lo: number, hi: number): number {
    return lo + this.int(hi - lo + 1);
  }

  /** 100분율 확률. pct=30이면 30% 확률로 true. */
  chance(pct: number): boolean {
    return this.int(100) < pct;
  }

  /** 상태 저장/복원 — 리플레이 분기점 검증에 쓴다. */
  save(): Int32Array {
    return Int32Array.from([this.a, this.b, this.c, this.d]);
  }

  load(s: Int32Array): void {
    this.a = s[0] >>> 0;
    this.b = s[1] >>> 0;
    this.c = s[2] >>> 0;
    this.d = s[3] >>> 0;
  }
}
